import {
  PortalBreadcrumbsPosition,
  PortalColorSchemas,
  PortalFooterType,
  PortalFooterWidth,
  PortalHeaderMenuAlign,
  PortalHeaderWidth,
  PortalSearchPosition,
  PortalSidebarType,
  PortalThemeConfig,
} from '@nx-frontend/shared/types';

export const portalThemeDefaultConfig: PortalThemeConfig = {
  header: {
    type: 'menu-right',
    width: PortalHeaderWidth.WIDE,
    sticky: false,
    className: ['px-3', 'py-7'],
    menu: { show: true, align: PortalHeaderMenuAlign.RIGHT },
    logo: { show: true, className: ['h-12', 'max-w-44'] },
    search: { show: false },
    notifications: { show: true },
  },
  hero: {
    show: false,
    type: 'empty',
    className: ['p-4'],
    blocks: {
      rtl: false,
    },
  },
  footer: {
    type: PortalFooterType.HIGH,
    width: PortalFooterWidth.WIDE,
    sticky: false,
  },
  search: {
    position: PortalSearchPosition.HEADER_HERO,
  },
  sidebar: {
    show: true,
    homePage: true,
    minimized: true,
    deepPage: true,
    type: PortalSidebarType.STANDARD,
  },
  secondbar: {
    show: false,
    homePage: false,
    deepPage: false,
  },
  breadcrumbs: {
    show: true,
    homePage: false,
    position: PortalBreadcrumbsPosition.OUTSIDE_CONTENT,
  },
  style: {
    radius: {
      className: ['rounded-lg'],
    },
    border: {
      className: ['border'],
    },
    shadow: {
      className: ['shadow-lg'],
    },
  },

  colors: {
    [PortalColorSchemas.LIGHT]: {
      key: 'light_purple',
    },
    [PortalColorSchemas.DARK]: {
      key: 'light_purple',
    },
  },
  content: {
    cols: {
      base: 2,
      md: 4,
      lg: 6,
    },
    gap: {
      base: 3,
      md: 4,
      lg: 6,
    },
  },
};
